import {
  Button,
  ButtonGroup,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import SaveIcon from "@mui/icons-material/Save";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Trans } from "react-i18next";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import StyleIcon from "@mui/icons-material/Style";
import ApprovalIcon from "@mui/icons-material/Approval";
import { DeleteForever } from "@mui/icons-material";
import PageNumberComponent from "./PageNumberComponent";
import { LOGO_IMG } from "../../constants";
export function FileHeader({
  headRef,
  setPDFCurrentPage,
  PDFCurrentPage,
  PDFNumPages,
  canSign,
  canDownload,
  isRejecting,
  setVisibleRejectModal,
  t,
  setVisibleSignatureModal,
  setVisibleStampModal,
  setVisibleAppearanceModal,
  setVisibleGlobalAppearanceModal,
  isSubmitting,
  submitSign,
  canNotSignNote,
  signatureImages,
  stampImages,
  activeSignature,
  deleteSignature,
  activeStamp,
  deleteStamp,
  file,
  fileTitle,
  isApprovalSigning,
  approvalSignatureFields,
  navigationFields,
  originalFields
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const signaturePages = Array.from(
    new Set((navigationFields || []).map((field) => field.page))
  ).sort((a, b) => a - b);

  const signedPagesCount = signaturePages.filter((pageNum) => {
    const pageFields = (navigationFields || []).filter(
      (field) => field.page === pageNum && Number(field.sign_status) !== 2
    );
    return (
      pageFields.length > 0 &&
      pageFields.every((field) => Number(field.sign_status) === 1)
    );
  }).length;

  const handleDownload = async () => {
    try {
      setLoadingDownload(true);
      let response = await fetch(file, {
        method: "get",
        responseType: "blob",
      });
      response = await response.blob();
      const objectURL = window.URL.createObjectURL(response);
      let link = document.createElement("a");
      link.href = objectURL;
      link.download = fileTitle + ".pdf";
      document.body.append(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link);
      setLoadingDownload(false);
    } catch (error) {
      setLoadingDownload(false);
      console.log("Download PDF issue: ", error);
    }
  };
  return (
    <header ref={headRef} className="pdf-file-header">
      <div className="header-left">
        <Button
          color="inherit"
          variant="text"
          className="back-btn"
          onClick={() => navigate("/app")}
        >
          <ChevronLeftIcon />{" "}
          <span style={{ fontSize: 14, fontWeight: 600 }}>Back</span>
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="cms-btn"
          onClick={() =>
            window.open(
              "https://bpm.omantel.om/teamworks/executecf?processApp=CMS&serviceName=Home",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          CMS
        </Button>
        <div className="logo">
          <LOGO_IMG />
        </div>
      </div>

      <div className="header-center">
        <div className="nav pdf-nav">
          <div className="page-controls">
            <button
              type="button"
              onClick={() => setPDFCurrentPage(PDFCurrentPage - 1)}
              disabled={PDFCurrentPage <= 1}
              aria-label="Previous page"
            >
              ‹
            </button>
            <span className="page-info">
              <PageNumberComponent
                currentPage={PDFCurrentPage}
                setPage={(val) => setPDFCurrentPage(val)}
                totalPages={PDFNumPages}
              />
              <span className="page-of">of</span>
              <p className="total-pages">{PDFNumPages}</p>
            </span>
            <button
              type="button"
              onClick={() => setPDFCurrentPage(PDFCurrentPage + 1)}
              disabled={PDFCurrentPage >= PDFNumPages}
              aria-label="Next page"
            >
              ›
            </button>
          </div>
        </div>

        {originalFields?.length > 0 && signaturePages.length > 0 && (
          <div className="signature-pages-nav">
            <div className="nav-meta">
              <span className="nav-label">
                {isApprovalSigning ? "Sign here" : "Review"}
              </span>
              <span className="nav-progress">
                {signedPagesCount}/{signaturePages.length}
              </span>
            </div>
            <div className="signature-pages-scroll" role="list">
              {signaturePages.map((pageNum) => {
                const isCurrentPage = pageNum === PDFCurrentPage;
                const pageFields = navigationFields.filter(
                  (field) =>
                    field.page === pageNum && Number(field.sign_status) !== 2
                );
                const isPageSigned =
                  pageFields.length > 0 &&
                  pageFields.every((field) => Number(field.sign_status) === 1);

                return (
                  <Tooltip
                    key={pageNum}
                    title={
                      isPageSigned
                        ? `Page ${pageNum} — signed`
                        : `Page ${pageNum} — pending`
                    }
                    arrow
                  >
                    <button
                      type="button"
                      role="listitem"
                      onClick={() => setPDFCurrentPage(pageNum)}
                      className={`page-nav-btn ${isCurrentPage ? "active" : ""} ${
                        isPageSigned ? "signed" : ""
                      }`}
                    >
                      {pageNum}
                    </button>
                  </Tooltip>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {!!canSign ? (
        <div className="actions-btns">
          {!!activeSignature && (
            <ButtonGroup color="inherit">
              <Tooltip title={t("appearance")}>
                <IconButton
                  color="inherit"
                  variant="text"
                  className={"sign icon"}
                  onClick={() => {
                    setVisibleAppearanceModal(true);
                  }}
                >
                  <StyleIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("delete_signature")}>
                <IconButton
                  color="error"
                  variant="text"
                  className={"sign icon"}
                  onClick={deleteSignature}
                >
                  <DeleteForever />
                </IconButton>
              </Tooltip>
            </ButtonGroup>
          )}
          {!!activeStamp && (
            <Tooltip title={t("delete_stamp")}>
              <IconButton
                color="error"
                variant="text"
                className={"sign icon large"}
                onClick={deleteStamp}
              >
                <DeleteForever />
              </IconButton>
            </Tooltip>
          )}
          <ButtonGroup color="inherit">
            <Tooltip title={t("global_appearance")}>
              <IconButton
                color="inherit"
                variant="text"
                className={"sign icon"}
                onClick={() => {
                  setVisibleGlobalAppearanceModal(true);
                }}
              >
                <StyleIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("reject")}>
              <IconButton
                disabled={
                  (signatureImages.length > 0 || stampImages.length > 0
                    ? true
                    : false) || isRejecting
                }
                color="inherit"
                variant="text"
                className={"sign icon"}
                onClick={() => {
                  setVisibleRejectModal(true);
                }}
              >
                {isRejecting && (
                  <CircularProgress
                    color="inherit"
                    style={{
                      width: "18px",
                      height: "18px",
                      marginInlineEnd: "6px",
                    }}
                  />
                )}
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("add_stamp")}>
              <IconButton
                color="inherit"
                variant="text"
                className={"sign icon"}
                onClick={() => {
                  setVisibleStampModal(true);
                }}
              >
                <ApprovalIcon />
              </IconButton>
            </Tooltip>
          </ButtonGroup>
          {false && (
            <>
              <Button
                id="sign-button"
                variant="contained"
                className={"sign"}
                disableElevation
                type="primary"
                aria-controls={open ? "sign-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <span className="main-icon">
                  <BorderColorIcon />
                </span>
                <span className="txt">{t("approval_sign")}</span>
              </Button>
              <Menu
                id="sign-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  style={{ minWidth: 100 }}
                  onClick={() => {
                    handleClose();
                    setVisibleSignatureModal(true);
                  }}
                >
                  <Trans>approval_sign</Trans>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    setVisibleStampModal(true);
                  }}
                >
                  <Trans>upload_stamp</Trans>
                </MenuItem>
              </Menu>
            </>
          )}
          {(signatureImages.length > 0 || stampImages.length > 0) && (
            <Tooltip title={t("general.save")}>
              <IconButton
                className={"save icon large"}
                onClick={submitSign}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress
                    color="inherit"
                    style={{
                      width: "18px",
                      height: "18px",
                      marginInlineEnd: "6px",
                    }}
                  />
                ) : (
                  <SaveIcon />
                )}
              </IconButton>
            </Tooltip>
          )}
        </div>
      ) : (
        <div className="actions-btns">
          {canNotSignNote && <p className="warning">{canNotSignNote}</p>}
          {canDownload && (
            <Button
              disabled={loadingDownload}
              color="error"
              variant="contained"
              className={"sign download_btn"}
              startIcon={
                loadingDownload ? (
                  <CircularProgress
                    color="inherit"
                    style={{
                      width: "18px",
                      height: "18px",
                      marginInlineEnd: "6px",
                    }}
                  />
                ) : (
                  <DownloadIcon />
                )
              }
              onClick={(e) => {
                e.preventDefault();
                handleDownload();
              }}
            >
              <span className="txt">{t("download_file")}</span>
            </Button>
          )}
        </div>
      )}
    </header>
  );
}
